import { styled } from 'styled-components';
import { breakpoint, spacing } from '../../../styles/helpers';

export const DisclaimerWrapper = styled.div`
  margin-bottom: ${spacing.xl};
  margin-top: ${spacing.xl};
  
  ${breakpoint.mobile} {
    margin-top: 0;
  }
`;
